/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from './Node';
import { Extension } from './Extension';
import { Document } from './Document';

/**
 * All data models that can be extended using the "x-*" approach to adding vendor extension
 * properties must extend this class.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends Node
 */
export abstract class ExtensibleNode extends Node {
    _extensions : any;

    /**
     * @see io.apicurio.datamodels.core.models.Node#isExtensible()
     * @return {boolean}
     */
    public isExtensible() : boolean {
        return true;
    }

    /**
     * Called to create an extension child.
     * @return {Extension}
     */
    public createExtension() : Extension {
        let extension : Extension = new Extension();
        extension._ownerDocument = this.ownerDocument();
        extension._parent = this;
        return extension;
    }

    /**
     * Called to add a named extension to this node.
     * @param {string} name
     * @param {Extension} extension
     */
    public addExtension(name : string, extension : Extension) {
        if(this._extensions == null) {
            this._extensions = <any>({});
        }
        /* put */(this._extensions[name] = extension);
    }

    /**
     * Returns all of the extensions defined on this node.
     * @return {Extension[]}
     */
    public getExtensions() : Array<Extension> {
        if(this._extensions != null) {
            return <any>(/* values */(obj => Object.keys(obj).map(key => obj[key]))(this._extensions).slice(0));
        } else {
            return null;
        }
    }

    /**
     * Gets a single extension by name.
     * @param {string} name
     * @return {Extension}
     */
    public getExtension(name : string) : Extension {
        let rval : Extension = null;
        if(this._extensions != null) {
            rval = /* get */((m,k) => m[k]===undefined?null:m[k])(this._extensions, name);
        }
        return rval;
    }

    /**
     * Removes a single extension by name.
     * @param {string} name
     */
    public removeExtension(name : string) {
        if(this._extensions != null) {
            /* remove */(map => { let deleted = this._extensions[name];delete this._extensions[name];return deleted;})(this._extensions);
        }
    }

    /**
     * Removes all extensions from this node.
     */
    public clearExtensions() {
        if(this._extensions != null) {
            /* clear */(obj => { for (let member in obj) delete obj[member]; })(this._extensions);
        }
    }

    constructor() {
        super();
        if(this._extensions===undefined) this._extensions = null;
    }
}
ExtensibleNode["__class"] = "io.apicurio.datamodels.core.models.ExtensibleNode";
ExtensibleNode["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




